import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Calendar, DollarSign, CheckCircle, Phone, Mail, MapPin, Clock } from 'lucide-react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Services from '../components/Services';
import PriceCalculator from '../components/PriceCalculator';
import About from '../components/About';
import Contact from '../components/Contact';

const LandingPage = () => {
  const [showBooking, setShowBooking] = useState(false);

  return (
    <div className="min-h-screen" style={{ background: '#FDFDFC' }}>
      <Header setShowBooking={setShowBooking} />
      <Hero setShowBooking={setShowBooking} />
      <Services />
      <PriceCalculator showBooking={showBooking} setShowBooking={setShowBooking} />
      <About />
      <Contact />
    </div>
  );
};

export default LandingPage;